// scroll bar
import 'simplebar/dist/simplebar.css';

// lazy image
import './utils/highlight';
import 'react-quill/dist/quill.snow.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
//
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { AuthProvider } from './contexts/AuthContexts';
import axios from 'axios';

// ----------------------------------------------------------------------

axios.defaults.timeout = 60000;
if (process.env.REACT_APP_DEBUG === 'true') {
  axios.defaults.baseURL = process.env.REACT_APP_URL_DEBUG;
} else {
  axios.defaults.baseURL = process.env.REACT_APP_URL_PRODUCT;
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <AuthProvider>
      <Provider store={store}>
        <SettingsProvider>
          <CollapseDrawerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </Provider>
    </AuthProvider>
  </HelmetProvider>
);
